import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Button, notification } from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import { EditFilled, PlusCircleFilled } from "@ant-design/icons";
const { Text } = Typography;

const LogisticsClientList = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [logisticsClientList, setLogisticsClientList] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "",
			dataIndex: "edit",
			width: 100,
			render: (_, record) => {
				return (
					<Button
						type="primary"
						icon={<EditFilled twoToneColor={"white"} />}
						onClick={(e) =>
							history.push(`/logistics/destination/update/${record.id}`)
						}
					/>
				);
			},
		},
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Address",
			dataIndex: "address",
			key: "address",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Latitude",
			dataIndex: "latitude",
			key: "latitude",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Longitude",
			dataIndex: "longitude",
			key: "longitude",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
	];

	useEffect(() => {
		getLogisticsClientList();
	}, []);

	const getLogisticsClientList = async () => {
		setLoading(true);

		const url = api + "/logistics/client/list/jap";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						name: item.name,
						latitude: item.latitude,
						longitude: item.longitude,
						address: item.address,
					});
				});
				setLogisticsClientList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const addNewLogisticsClient = () => {
		history.push("/logistics/destination/new");
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Button
					onClick={addNewLogisticsClient}
					type="primary"
					size="large"
					style={{
						width: 210,
					}}
					icon={<PlusCircleFilled />}
				>
					New Logistics Client
				</Button>
				<CustomTable
					columns={columns}
					data={logisticsClientList}
					isScroll={false}
				/>
			</Flex>
		);
	};

	return (
		<Layout title="Logistics Clients" description="Client List">
			<Flex vertical gap={"large"}>
				{loading ? <CustomSpinner /> : <RenderTable />}
				{contextHolder}
			</Flex>
		</Layout>
	);
};

export default LogisticsClientList;
